const React = require("react")
const PageTransition = require("./src/components/pageTransition").default

let oldPathname = null

exports.onPreRouteUpdate = ({ location, prevLocation }) => oldPathname = prevLocation ? prevLocation.pathname : null

exports.wrapPageElement = ({ element, props }) => <PageTransition oldPathname={oldPathname} {...props}>{element}</PageTransition>